import { render, staticRenderFns } from "./beforeOffice.vue?vue&type=template&id=b436c1d0&scoped=true"
import script from "./beforeOffice.vue?vue&type=script&lang=js"
export * from "./beforeOffice.vue?vue&type=script&lang=js"
import style0 from "./beforeOffice.vue?vue&type=style&index=0&id=b436c1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b436c1d0",
  null
  
)

export default component.exports